export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Waluta"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Utwórz raport"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wynik waluty"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pobrać"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Arkusz"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dozwolony format pliku - xlsx"])}
}